import React, { useState, useEffect } from "react";
import axios from "axios";
import Pusher from "pusher-js";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Card,
  CircularProgress,
  BottomNavigation,
  BottomNavigationAction,
  Avatar,
} from "@mui/material";
import {
  Notifications as NotificationsIcon,
  Chat as ChatIcon,
  AccountCircle as AccountCircleIcon,
  CalendarToday as CalendarTodayIcon,
  Home as HomeIcon,
  Payment as PaymentIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_APP_URL;

  const token = localStorage.getItem("CC_Token");
  const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
  const userId = user?.id || null;

  const fetchNotifications = async () => {
    if (!token || !userId) {
      console.error("Token or user ID is missing.");
      setLoading(false);
      return;
    }

    try {
      const userNotifications = await axios.get(`${baseUrl}/api/notifications/user/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const generalNotifications = await axios.get(`${baseUrl}/api/notifications`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const allNotifications = [...userNotifications.data, ...generalNotifications.data].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      setNotifications(allNotifications);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userId) return;

    fetchNotifications();

    if (Notification.permission === "default") Notification.requestPermission();

    const pusher = new Pusher("aebc2eec94386d5d25a3", { cluster: "mt1", forceTLS: true });
    const globalChannel = pusher.subscribe("global.notifications");
    globalChannel.bind("NotificationCreated", (data) => {
      setNotifications((prev) => [data, ...prev]);
      if (Notification.permission === "granted") {
        navigator.serviceWorker.ready.then(registration => {
          registration.showNotification(data.title, {
            body: data.message,
            icon: "/icon.png",
            data: { url: data.url }
          });
        });
      }
    });

    const userChannel = pusher.subscribe(`NotificationByUser.${userId}.notifications`);
    userChannel.bind("NotificationByUser", (data) => {
      setNotifications((prev) => [data,...prev ]);
      if (Notification.permission === "granted") {
        new Notification(data.title, { body: data.message });
      }
    });

    return () => {
      globalChannel.unbind_all();
      userChannel.unbind_all();
      pusher.unsubscribe("global.notifications");
      pusher.unsubscribe(`NotificationByUser.${userId}.notifications`);
      pusher.disconnect();
    };
  }, [userId]);
  const handleProfile = () => {
    navigate("/Profile");
  };
   const handleLogout = () => {
      localStorage.removeItem("CC_Token");
      localStorage.removeItem("user");
      toast.success("Vous avez été déconnecté avec succès.", {
        position: "top-right",
        autoClose: 3000,
      });
      setTimeout(() => navigate("/login"), 4000); // Redirect after toast
    };
  
    const handleNavigateToNotifications = () => {
      navigate("/notifications");
    };

  return (
    <div className="notifications-page" style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar
            alt="Logo"
            src={"../assets/cej.png"}
            sx={{ width: 40, height: 40, marginRight: "0.5rem" }}
          />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Contenu principal */}
      <Box
        sx={{
          flex: 1,
          padding: "1rem",
          paddingTop: "70px", // Hauteur du header
          paddingBottom: "70px", // Hauteur du footer
          backgroundColor: "#f5f5f5",
          overflowY: "auto",
        }}
      >
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
            <CircularProgress color="primary" />
            <Typography sx={{ marginLeft: "1rem", color: "#555" }}>
              Chargement des notifications...
            </Typography>
          </Box>
        ) : notifications.length > 0 ? (
          notifications.map((notification) => (
            <Card key={notification.id} sx={{ marginBottom: "0.5rem", padding: "1rem", borderRadius: "15px" }}>
              <Typography sx={{ fontWeight: 500, color: "#003366" }}>
                {notification.title}
              </Typography>
              <Typography sx={{ color: "#555555" }}>
                {notification.message}
              </Typography>
              <Typography sx={{ color: "#888888", marginTop: "0.5rem", fontSize: "0.8rem" }}>
                {new Date(notification.created_at).toLocaleString()}
              </Typography>
            </Card>
          ))
        ) : (
          <Typography>Aucune notification trouvée.</Typography>
        )}
      </Box>

      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%", zIndex: 10 }}>
        <BottomNavigation sx={{ backgroundColor: "#003366" }}>
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            onClick={() => navigate("/emploi")}
          />
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            onClick={() => navigate("/home")}
          />
          <BottomNavigationAction
            label="Paiement"
            icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            onClick={() => navigate("/payment")}
          />
        </BottomNavigation>
      </Box>
    </div>
  );
};

export default NotificationsPage;
